import * as React from "react";

import './SetScoreHistory.scss';
import { SetScoreHistoryEntry } from "./SetScoreHistoryEntry";
import { TickerMatchSet } from "../../models";

interface Props {
  matchSets: TickerMatchSet[]
}

export const SetScoreHistory = React.memo((props: Props) => {
  const { matchSets } = props
  return (
    <div className="SetScoreHistory">
      {matchSets.map((ms, i) => <SetScoreHistoryEntry score={ms.setScore} key={i} isGoldenSet={ms.isGoldenSet} setNumber={i + 1} />)}
    </div>
  )
})
